import { useContext } from 'react'
import { ResponsiveContext } from './ResponsiveContext'

export const useResponsiveMatches = () => useContext(ResponsiveContext).matches
